<template>
    <div v-if="config.pages_enabled" :class="theme.wrapper" class="form-inline">
        <span>Items on Page:</span>
        <select
            ref="options"
            v-model="props.page_size"
            class="form-control form-control-sm ml-2"
            @change="change"
        >
            <option
                v-for="option in pageSizeOptions"
                :key="`page-size-option-${option.value}`"
                :value="option.value"
                v-text="option.label"
            />
        </select>
    </div>
</template>

<script>
import Common from './mixins/Common.vue';
import ReloadsGrid from './mixins/ReloadsGrid.vue';

export default {
    mixins: [Common, ReloadsGrid],
    props: {
        data: Object,
    },
    computed: {
        pageSizeOptions() {
            const options = [];

            if (this.config.automatic_page_size_enabled) {
                options.push({
                    label: this.config.automatic_page_size_label,
                    value: 'auto',
                });
            }

            this.config.page_size_options.forEach(option => {
                options.push({
                    label: option,
                    value: option,
                });
            });

            if (this.config.show_all_enabled) {
                options.push({
                    label: this.config.show_all_label,
                    value: 'all',
                });
            }

            return options;
        },
    },
    methods: {
        change() {
            if (this.props.page_size === 'auto') {
                this.props.page_size_actual = Number(
                    this.props.automatic_page_size,
                );
            } else if (this.props.page_size === 'all') {
                this.props.page_size_actual = null;
            } else {
                this.props.page_size_actual = Number(this.props.page_size);
            }

            this.bus.$emit('paze-size-changed');
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/page_size_control.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/page_size_control.scss"
></style>
